module.exports = __webpack_public_path__ + "static/IS3-7ea5555feeff70d9305c9382c61f84bb.jpg";